// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39308","brands":"styles_brands__13_qS","wideBrands":"styles_wideBrands__3BeRo","brandsMobile":"styles_brandsMobile__3tV7n"};